import axios from 'axios';
import jwtDecode from 'jwt-decode';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from 'routes';
import { signIn, tokenToUser } from 'state/auth';
import styled from 'styled-components';
import { colors } from 'styles/colors';

import MainTemplate from 'templates/MainTemplate/MainTemplate';

import Button from 'ui/Button';
import { WhiteWrapper } from 'ui/WhiteWrapper';

const PLConsent = () => (
   <Content>
      <div>
         <h1>REGULAMIN PORTALU KONSPORT PLATFORMA INFORMACYJNA</h1>
      </div>
      <div>
         <h2>
            § 1<br />
            Postanowienia ogólne
         </h2>
         <ol>
            <li>
               Niniejszy regulamin określa zasady korzystania przez podmioty uprawnione, zwanych
               dalej „Użytkownikami” z portalu KONSPORT PLATFORMA INFORMACYJNA, zwanego dalej także
               jako „Portal”.
            </li>
            <li>
               Administratorem Portalu jest KONSPORT MAJEWSCY SPÓŁKA JAWNA z siedzibą w Dobkowie,
               wpisaną do Rejestru Przedsiębiorców Krajowego Rejestru Sądowego pod nr KRS 0000674619
               (Sąd rejestrowy: Sąd Rejonowy dla Łodzi-Śródmieścia w Łodzi), NIP: 5252708327, REGON:
               367115411, Dobków 1, 98-105 Wodzierady.
            </li>
            <li>
               W oparciu o treść niniejszego Regulaminu Administrator nieodpłatnie udostępnia
               zarejestrowanym podmiotom, zwanym dalej jako Użytkownicy lub Użytkownik informacje i
               materiały zgromadzone w Portalu.
            </li>
            <li>Warunkiem korzystania z Portalu jest rejestracja oraz akceptacja Regulaminu.</li>
            <li>
               Użytkownik w celu uzyskania dostępu do portalu ma obowiązek przekazania
               Administratorowi wypełnionego formularza rejestracji drogą elektroniczną lub na
               piśmie.
            </li>
            <li>
               Dostęp do Portalu może uzyskać wyłącznie pełnoletnia osoba fizyczna prowadząca
               działalność gospodarczą zarejestrowaną w CEIDG lub podmiot zarejestrowany w Rejestrze
               Przedsiębiorców Krajowego Rejestru Sądowego lub inny podmiot zawodowo stale
               współpracujący z Administratorem lub podmiotami powiązanymi.
            </li>
            <li>
               Przez podmioty powiązane należy rozumieć w szczególności: Mieczysław Majewski
               prowadzący działalność gospodarczą pod firmą PRZEDSIĘBIORSTWO &quot;KONSPORT&quot;
               Mieczysław Majewski, Konsport Montaż Spółka z ograniczoną odpowiedzialnością Sp. k. z
               siedzibą w Dobkowie.
            </li>
            <li>
               Każde logowanie do Portalu oznacza akceptację aktualnie obowiązującego Regulaminu.
               Brak akceptacji Regulaminu uniemożliwi dalsze korzystanie z Portalu.
            </li>
         </ol>
      </div>
      <div>
         <h2>
            § 2 <br />
            Zasoby portalu
         </h2>
         <ol>
            <li>
               Portal zawiera informacje oraz materiały dotyczące produktów i rozwiązań oferowanych
               przez Administratora i podmioty powiązane, w szczególności są to katalogi produktów,
               cenniki, instrukcje, narzędzia projektowe oraz konfiguracje produktów.
            </li>
            <li>
               Informacje i materiały publikowane w Portalu mają charakter wyłącznie poglądowy, są
               publikowane celem pozyskania przez Użytkowników wiadomości na temat dostępnych
               produktów i rozwiązań oferowanych przez Administratora oraz podmioty powiązane.
            </li>
            <li>
               Informacje i materiały publikowane w Portalu stanowią odzwierciedlenie katalogu
               produktów oferowanych przez Administratora, w szczególności stanowią podstawę do
               określenia nazewnictwa i systemu kodyfikacji stosowanego w cennikach, katalogach i
               katalogach technicznych oraz wymiarów, kolorystyki, ilości i gotowych rozwiązań
               możliwych do uzyskania przy wykorzystaniu oferowanego towaru.
            </li>
            <li>
               Administrator umożliwia dokonanie zamówienia towaru przez portal Strefa Dystrybutora,
               prowadzony pod odrębnym adresem.
            </li>
         </ol>
      </div>
      <div>
         <h2>
            § 3 <br />
            Uprawnienia Użytkownika
         </h2>
         <ol>
            <li>
               Każdy zarejestrowany Użytkownik otrzymuje indywidualny login i hasło umożliwiające
               dostęp do treści publikowanych w Portalu oraz indywidualny profil.
            </li>
            <li>
               Użytkownik ma prawo do wykorzystania informacji i materiałów publikowanych w portalu
               wyłącznie na potrzeby własnej działalności gospodarczej lub zawodowej.
            </li>
            <li>
               Użytkownik ma obowiązek zabezpieczyć login i hasło przed wykorzystaniem przez osoby
               trzecie, a w przypadku powzięcia przez Użytkownika informacji na temat ujawnienia
               tych danych podmiotom nieuprawnionym zobowiązany jest do niezwłocznego poinformowania
               o tym Administratora
            </li>
            <li>
               Użytkownik ma obowiązek zabezpieczyć wszelkie treści pochodzące z Portalu przed
               wykorzystaniem przez osoby trzecie.
            </li>
            <li>
               Użytkownik ma prawo do żądania usunięcia profilu, a Administrator ma obowiązek
               usunięcia profilu niezwłocznie po zgłoszeniu takiego żądania.
            </li>
         </ol>
      </div>
      <div>
         <h2>
            § 4 <br />
            Ochrona zasobów
         </h2>
         <ol>
            <li>
               Wszelkie prawa autorskie do treści opublikowanych w Portalu posiada Administrator i
               podmioty powiązane.
            </li>
            <li>
               Użytkownik akceptuje fakt, iż informacje i materiały opublikowane w Portalu, w
               szczególności dotyczące technologii produkcji, sposobów gięcia i spawania, wymiarów
               gięcia i spawania, stanowią stanowią prawnie chronioną tajemnicę przedsiębiorstwa.
               Użytkownik zobowiązuje się do wykorzystywania ich wyłącznie w zgodzie z
               postanowieniami niniejszego Regulaminu i powszechnie obowiązującymi przepisami prawa.
            </li>
            <li>
               Użytkownik akceptuje fakt, że układ i kompozycja stron, nawigacja, elementy
               graficzne, interaktywne aplikacje, zdjęcia, teksty i inne materiały stanowią własność
               Administratora i są prawnie chronione.
            </li>
            <li>
               Użytkownik akceptuje fakt, iż wszelkiego rodzaju kopiowanie, naśladowanie,
               odwzorowywanie produktów i rozwiązań oferowanych przez Administratora, a także
               wykorzystywanie, kopiowanie, udostępnianie i przekazywanie dalej w powyższym celu
               informacji i materiałów publikowanych w Portalu będzie skutkowało powstaniem
               odpowiedzialności odszkodowawczej Użytkownika.
            </li>
            <li>
               Użytkownik akceptuje fakt, iż naruszenie praw opisanych w ust. 1-3 lub stwierdzenie
               przez Administratora zaistnienia okoliczności opisanych w ust. 4 niniejszego
               paragrafu, uprawnia Administratora do natychmiastowego wstrzymania dostępu do Portalu
               i podjęcia dalszych kroków prawnych, w szczególności mających na celu dochodzenie
               naprawienia powstałej w związku z tym szkody bez uprzedniego wzywania do zaprzestania
               ww. naruszeń.
            </li>
            <li>
               W przypadku powzięcia przez Użytkownika informacji na temat naruszenia praw opisanych
               w ust. 1-3 oraz okoliczności opisanych w ust. 4 jest zobowiązany do niezwłocznego
               poinformowania o tym Administratora.
            </li>
         </ol>
      </div>
      <div>
         <h2>
            § 5 <br />
            Pobieranie zasobów
         </h2>
         <ol>
            <li>
               Użytkownik akceptuje fakt, że odnotowane przez Administratora we właściwym systemie
               mogą być:
               <ol type="a">
                  <li>każdorazowe logowanie do Portalu;</li>
                  <li>każdorazowe pobranie materiałów z Portalu;</li>
                  <li>każdorazowe wykorzystanie narzędzi konfiguracyjnych (projektowych).</li>
               </ol>
            </li>
            <li>
               Dane dotyczące działań Użytkownika opisanych w ust. 1 Administrator zobowiązuje się
               wykorzystywać wyłącznie w celu zabezpieczenia publikowanych w Portalu treści, w
               granicach powszechnie obowiązujących przepisów prawa.
            </li>
         </ol>
      </div>
      <div>
         <h2>
            § 6 <br />
            Ochrona danych osobowych
         </h2>
         <p>
            Zgodnie z art. 13 ust. 1 i ust. 2 rozporządzenia Parlamentu Europejskiego i Rady (UE)
            2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z
            przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz
            uchylenia dyrektywy 95/46/WE syndyk masy upadłości informuje, że:
         </p>
         <ol>
            <li>
               Administratorem danych osobowych przekazanych przez Użytkowników jest KONSPORT
               MAJEWSCY SPÓŁKA JAWNA z siedzibą w Dobkowie, wpisaną do Rejestru Przedsiębiorców
               Krajowego Rejestru Sądowego pod nr KRS 0000674619 (Sąd rejestrowy: Sąd Rejonowy dla
               Łodzi-Śródmieścia w Łodzi), NIP: 5252708327, REGON: 367115411, Dobków 1, 98-105
               Wodzierady.
            </li>
            <li>
               Dane osobowe przekazane przez Użytkowników przetwarzane będą w zakresie niezbędnym do
               prowadzenia Portalu.
            </li>
            <li>
               Odbiorcą danych osobowych będą współpracownicy Administratora Danych, w zakresie
               niezbędnym do prowadzenia Portalu.
            </li>
            <li>
               Dane osobowe będą przechowywane w czasie, w którym Użytkownik posiada dostęp do
               portalu oraz przez okres 6 lat od wygaśnięcia dostępu.
            </li>
            <li>
               Użytkownikowi przysługuje prawo dostępu do danych osobowych, prawo do żądania
               poprawienia, usunięcia lub ograniczenia przetwarzania tych danych, prawo do
               przenoszenia danych, z zastrzeżeniem obowiązku przechowywania danych w czasie, gdy
               Użytkownik posiada aktywny dostęp.
            </li>
            <li>
               Użytkownik ma prawo wniesienia skargi do organu nadzoru, gdy uzna, iż przetwarzanie
               danych osobowych dotyczących oferenta narusza przepisy.
            </li>
            <li>
               Podanie przez Użytkownika danych osobowych jest warunkiem uzyskania dostępu do
               Portalu.
            </li>
            <li>
               Dane przekazane przez Użytkownika nie będą przetwarzane w sposób zautomatyzowany, w
               tym również w formie profilowania.
            </li>
            <li>
               Dane osobowe przekazane przez Użytkownika nie będą przekazywane przez Administratora
               do Państw trzecich.
            </li>
         </ol>
      </div>
      <div>
         <h2>
            § 7 <br />
            Pliki cookies
         </h2>
         <ol>
            <li>
               Administrator automatycznie zbiera dane osobowe Użytkowników za pomocą Plików
               Cookies.
            </li>
            <li>
               Administrator wykorzystuje następujące typy Plików Cookies:
               <ol type="a">
                  <li>
                     Cookies niezbędne – są niezbędne do funkcjonowania strony internetowej i nie
                     mogą być wyłączone w naszych systemach. Niezbędne Cookies są zazwyczaj używane
                     w odpowiedzi na działania podejmowane przez użytkownika, takie jak: ustawienie
                     opcji prywatności, logowanie się lub wypełnianie formularzy. Możecie Państwo
                     zmienić ustawienia swojej przeglądarki tak, aby je zablokować, jednak strona
                     nie będzie wtedy funkcjonowała prawidłowo.
                  </li>
                  <li>
                     Cookies funkcjonalne - są przechowywane na urządzeniu użytkownika i pozostają
                     tam do momentu zakończenia sesji danej przeglądarki. te Cookies są obowiązkowe,
                     aby niektóre aplikacje lub funkcjonalności działały poprawnie.
                  </li>
                  <li>
                     Cookies stałe - są przechowywane na urządzeniu użytkownika i pozostają tam do
                     momentu ich skasowania. Dzięki nim korzystanie z często odwiedzanych stron jest
                     łatwiejsze (np. zapewniają optymalną nawigację, zapamiętują wybraną
                     rozdzielczość, układ treści itp.). Zakończenie sesji danej przeglądarki lub
                     wyłączenie urządzenia nie powoduje ich usunięcia z urządzenia użytkownika.
                  </li>
               </ol>
            </li>
            <li>
               Pliki Cookies są wykorzystywane w celu podnoszenia jakości świadczonych usług,
               poprawianie wyników wyszukiwania strony internetowej jak i trafności wyświetlanych
               informacji oraz śledzenia Państwa preferencji.
            </li>
            <li>
               Użytkownik w każdym momencie może samodzielnie zmienić ustawienia dotyczące Cookies i
               określić warunki, na jakich Cookies są przechowywane na urządzeniu i uzyskują do
               niego dostęp. Ustawienia dotyczące Cookies można zmienić za pomocą ustawień
               przeglądarki internetowej lub za pomocą konfiguracji usługi. Ustawienia te mogą
               przede wszystkim blokować automatyczną obsługę Cookies w ustawieniach przeglądarki
               internetowej lub każdorazowo informować, że Cookies zostały zamieszczone na
               urządzeniu. Szczegółowe informacje o możliwości i sposobach obsługi Cookies znajdują
               w ustawieniach przeglądarki internetowej.
            </li>
            <li>
               Użytkownik może w każdej chwili usunąć pliki Cookies korzystając z dostępnych funkcji
               w przeglądarce internetowej, której używa.
            </li>
            <li>
               Ograniczenie stosowania plików Cookies, może wpłynąć na niektóre funkcjonalności
               dostępne na stronie internetowej.
            </li>
         </ol>
      </div>
      <div>
         <h2>
            § 8 <br />
            Postanowienie końcowe
         </h2>
         <ol>
            <li>
               W zakresie nieuregulowanym postanowieniami niniejszego Regulaminu, do stosunków
               pomiędzy stronami znajdują zastosowanie Ogólne Warunki Sprzedaży obowiązujące u
               Administratora oraz powszechnie obowiązujące przepisy prawa.
            </li>
            <li>
               Wszelkie spory powstałe na gruncie korzystania z Portalu strony zobowiązują się
               rozwiązywać polubownie. W wypadku, gdy pozasądowe działania nie doprowadzą do
               rozstrzygnięcia sporu, sądem miejscowo właściwym dla jego rozstrzygnięcia będzie sąd
               dla dzielnicy Śródmieście w Łodzi.
            </li>
            <li>
               O każdej zmianie postanowień niniejszego Regulaminu Użytkownik zostanie poinformowany
               za pośrednictwem Portalu oraz na adres poczty elektronicznej podany przy rejestracji
               z dwutygodniowym wyprzedzeniem.
            </li>
         </ol>
      </div>
   </Content>
);

const ENGConsent = () => (
   <Content>
      <div>
         <h1>TERMS AND CONDITIONS OF THE KONSPORT PORTAL INFORMATION PLATFORM</h1>
      </div>
      <div>
         <h2>
            § 1<br />
            General Provisions
         </h2>
         <ol>
            <li>
               These Terms and Conditions define the rules for the use of the KONSPORT INFORMATION
               PLATFORM, hereinafter referred to as the &quot;Portal&quot;, by authorised entities,
               hereinafter referred to as &quot;Users&quot;.
            </li>
            <li>
               The Administrator of the Portal is KONSPORT MAJEWSCY SPÓŁKA JAWNA, with its
               registered office in Dobków, registered in the Register of Entrepreneurs of the
               National Court Register under KRS no. 0000674619 (Register Court: District Court for
               Łódź-Śródmieście in Łódź), NIP: 5252708327, REGON: 367115411, Dobków 1, 98-105
               Wodzierady.
            </li>
            <li>
               Based on the content of these Terms and Conditions, the Administrator provides
               registered subjects, hereinafter referred to as the User, with information and
               materials collected on the Portal free of charge.
            </li>
            <li>
               Use of the Portal is subject to registration and acceptance of the Terms and
               Conditions.
            </li>
            <li>
               To access the portal, the User is obliged to provide the Administrator with a
               completed registration form by electronic means or in writing.
            </li>
            <li>
               Access to the Portal may be obtained only by an adult natural person running a
               business registered in CEIDG or an entity registered in the Register of Entrepreneurs
               of the National Court Register, or another entity permanently cooperating with the
               Administrator or related entities.
            </li>
            <li>
               Related entities should be understood in particular as: Mieczysław Majewski
               conducting business activity under the name PRZEDSIĘBIORSTWO &quot;KONSPORT&quot;
               Mieczysław Majewski, Konsport Montaż Spółka z ograniczoną odpowiedzialnością Sp. k.
               with its registered office in Dobków.
            </li>
            <li>
               Each login to the Portal means accepting the current Terms and Conditions. Failure to
               accept the Terms and Conditions will prevent the further use of the Portal.
            </li>
         </ol>
      </div>
      <div>
         <h2>
            § 2 <br />
            Portal Resources
         </h2>
         <ol>
            <li>
               The portal contains information and materials concerning products and solutions
               offered by the Administrator and related entities, in particular product catalogues,
               price lists, instructions, design tools, and product configurations.
            </li>
            <li>
               The information and materials published on the Portal are for illustrative purposes
               only and are published to enable Users to obtain information about the available
               products and solutions offered by the Administrator and related entities.
            </li>
            <li>
               The information and materials published on the Portal reflect the catalogue of
               products offered by the Administrator; in particular, they are the basis for the
               nomenclature and codification system used in price lists, catalogues and technical
               catalogues, as well as the dimensions, colours, quantities and finished solutions
               possible with the use of the offered goods.
            </li>
            <li>
               The Administrator allows you to order goods through the Distributor Zone portal,
               which is hosted at a separate address.
            </li>
         </ol>
      </div>
      <div>
         <h2>
            § 3 <br />
            Users&apos;&apos; Rights
         </h2>
         <ol>
            <li>
               Each registered user will receive a unique login and password to access the content
               published on the Portal and a unique profile.
            </li>
            <li>
               The User has the right to use the information and material published on the Portal
               exclusively for their own business or professional activity.
            </li>
            <li>
               The User is obliged to protect the login and password against use by third parties,
               and if the User becomes aware of the disclosure of this data to unauthorised parties,
               the User is obliged to notify the Administrator immediately.
            </li>
            <li>
               The User is obliged to protect all content from the Portal against being used by
               third parties.
            </li>
            <li>
               The User has the right to request the deletion of the profile, and the Administrator
               is obliged to delete the profile immediately after such a request is submitted.
            </li>
         </ol>
      </div>
      <div>
         <h2>
            § 4 <br />
            Protecting resources
         </h2>
         <ol>
            <li>
               The Administrator and related entities possess all copyrights to the content
               published on the Portal.
            </li>
            <li>
               The User accepts that the information and materials published on the Portal, in
               particular regarding production technology, bending and welding methods, as well as
               bending and welding dimensions, constitute the Company&apos;&apos;s legally protected
               trade secret. The User undertakes to use them only following the provisions of these
               Terms and Conditions and generally applicable laws.
            </li>
            <li>
               The User accepts that the layout and composition of the pages, navigation, graphic
               elements, interactive applications, photos, texts and other materials are the
               property of the Administrator and are protected by law.
            </li>
            <li>
               The User accepts the fact that any type of copying, imitating, recreating products
               and solutions offered by the Administrator, as well as using, copying, sharing, and
               forwarding of information and materials published on the Portal for the above purpose
               will result in the User&apos;&apos;s liability for damages.
            </li>
            <li>
               The User accepts the fact that violating the rights described in sec. 1-3 or
               determined by the Administrator the occurrence of the circumstances described in sec.
               4 of this paragraph entitles the Administrator to immediately suspend access to the
               Portal and undertake further legal steps, especially such that seek redress for the
               damage caused in connection with it without calling to stop the above-mentioned
               violations.
            </li>
            <li>
               If the User becomes aware of violating the rights described in sec. 1-3 and the
               circumstances described in sec. 4 the User is obliged to immediately inform the
               Administrator about it.
            </li>
         </ol>
      </div>
      <div>
         <h2>
            § 5 <br />
            Downloading resources
         </h2>
         <ol>
            <li>
               The User accepts the fact that the Administrator may record the following in the
               appropriate system:
               <ol type="a">
                  <li>each logging into the Portal;</li>
                  <li>each download of materials from the Portal;</li>
                  <li>each time the configuration (design) tools are used.</li>
               </ol>
            </li>
            <li>
               Data concerning the User&apos;&apos;s actions described in sec. 1 The Administrator
               undertakes to use only to secure the content published on the Portal, within the
               limits of generally applicable law.
            </li>
         </ol>
      </div>
      <div>
         <h2>
            § 6 <br />
            Protection of personal data
         </h2>
         <p>
            Under Article 13 sec. 1 and sec. 2 of the General Data Protection Regulation -
            Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016
            on the protection of individuals (natural persons) with regard to the processing of
            personal data and on the free movement of such data and the repeal of Directive
            95/46/EC, the trustee in bankruptcy hereby notifies that:
         </p>
         <ol>
            <li>
               The Controller of the personal data provided by the User is KONSPORT MAJEWSCY SPÓŁKA
               JAWNA with its registered office in Dobków, registered in the National Court Register
               under KRS no. 0000674619 (Registered office: District Court for Łódź - Śródmieście in
               Łódź), NIP: 5252708327, REGON: 367115411, Dobków 1, 98-105 Wodzierady.
            </li>
            <li>
               Personal data provided by users will be processed to the extent necessary for the
               operation of the Portal.
            </li>
            <li>
               The recipient of personal data will be co-workers of the Data Controller, to the
               extent necessary to run the Portal.
            </li>
            <li>
               Personal data will be stored during the period in which the User has access to the
               portal and for a period of 6 years from the expiry of that access.
            </li>
            <li>
               The User has the right to access personal data, the right to request correction,
               deletion, or limitation of the processing of such data, and the right to transfer
               data, subject to the obligation to store data while the User possesses active access.
            </li>
            <li>
               The User has the right to lodge a complaint with the supervisory authority if the
               User considers that the processing of personal data concerning the bidder violates
               the provisions.
            </li>
            <li>
               Providing the User&apos;&apos;s personal data is necessary for gaining access to the
               Portal.
            </li>
            <li>
               The data provided by the User will not be processed in an automated manner, including
               in the form of profiling.
            </li>
            <li>
               The Controller will not transfer personal data provided by the User to third
               countries.
            </li>
         </ol>
      </div>
      <div>
         <h2>
            § 7 <br />
            Cookies
         </h2>
         <ol>
            <li>
               The Administrator automatically collects Users&apos;&apos; personal data using Cookie
               Files.
            </li>
            <li>
               The administrator uses the following types of Cookies:
               <ol type="a">
                  <li>
                     Necessary Cookies – they are necessary for the website&apos;&apos;s functioning
                     and cannot be disabled in our systems. Necessary Cookies are typically used in
                     response to actions undertaken by the User, such as setting privacy options,
                     logging in, or filling out forms. You can change your browser settings to block
                     them, however, the website will then not function properly.
                  </li>
                  <li>
                     Functional Cookies - they are stored on the user&apos;&apos;s device and remain
                     there until the end of the session of a given browser. These Cookies are
                     necessary for some applications or functionalities to work properly.
                  </li>
                  <li>
                     Permanent cookies - are stored on the User&apos;&apos;s device and remain there
                     until deleted. They make it easier to use frequently visited pages (e.g. they
                     provide optimal navigation, remember the selected resolution, content layout,
                     etc.). Ending a browser session or turning off the device does not erase them
                     from the User&apos;&apos;s device.
                  </li>
               </ol>
            </li>
            <li>
               Cookies are used to improve the quality of the services provided, to improve the
               site&apos;&apos;s search results and the accuracy of the information displayed, and
               to track User preferences.
            </li>
            <li>
               The User may at any time independently change the Cookie settings and specify the
               conditions for storing Cookies on the device and the manner in which they access it.
               Cookie settings can be changed by using your web browser settings or by configuring
               the service. These settings can primarily block the automatic handling of Cookies in
               the web browser settings or inform each time that Cookies have been placed on the
               device. Detailed information concerning the possibilities and methods of handling
               cookies can be found in the web browser settings.
            </li>
            <li>
               The User may delete cookie files from their device at any time using the functions
               available in their browser.
            </li>
            <li>Limiting Cookies can affect some functions available on the Website.</li>
         </ol>
      </div>
      <div>
         <h2>
            § 8 <br />
            Final Provisions
         </h2>
         <ol>
            <li>
               In matters not covered by the provisions of these Terms and Conditions, the General
               Terms and Conditions of Sale in force at the Administrator and generally applicable
               provisions of law shall apply to the relations between the parties.
            </li>
            <li>
               The Parties undertake to resolve any disputes arising from using the Portal amicably.
               If out-of-court proceedings do not lead to the settlement of the dispute, the court
               for the district of Śródmieście in Łódź shall be competent to settle the dispute.
            </li>
            <li>
               The User will be informed two weeks in advance of any changes to the provisions of
               these Terms and Conditions through the Portal and at the email address provided
               during registration.
            </li>
         </ol>
      </div>
   </Content>
);

const CatalogConsentView = () => {
   const dispatch = useDispatch();
   const nav = useNavigate();
   const { state } = useLocation();
   const user = useSelector((s) => s.auth.user);
   const agree = () =>
      axios.post(`kns/users/${user.id}/consents/catalog`).then(() => {
         // generate token again, this time with consent time
         axios
            .post('/jwt-auth/v1/token', {
               username: state.username,
               password: state.password
            })
            .then((res) => {
               localStorage.setItem('token', res.data.token);

               axios.defaults.headers['Authorization'] = `Bearer ${res.data.token}`;

               const t = jwtDecode(res.data.token);
               const u = tokenToUser(t);
               dispatch(signIn(u));

               if (u.consentApprovedAt) {
                  nav(routes.catalog);
               } else {
                  throw new Error('empty consent');
               }
            });
      });

   const consentApprovedAt = !!user?.consentApprovedAt;

   useEffect(() => {
      if (consentApprovedAt) nav(routes.catalog);
   }, [consentApprovedAt]);

   return (
      <MainTemplate background="dark">
         <WhiteWrapper>
            <PLConsent />
            <ENGConsent />
            <Approve>
               <Button type="button" onClick={agree}>
                  Zgadzam się / Agree
               </Button>
            </Approve>
         </WhiteWrapper>
      </MainTemplate>
   );
};

const Content = styled.div`
   margin: 2rem 0;
   text-align: center;
   color: ${colors.white};

   ol {
      text-align: justify;
   }
`;

const Approve = styled.div`
   display: flex;
   justify-content: center;
`;

export default CatalogConsentView;
